import GameModel from "./GameModel";
import Config from "../../../../../shared/src/ranj/app/config/Config";
import BaseSaveModel from "../../../../../shared/src/ranj/equalture/savegame/BaseSaveModel";

export default class SaveModel extends BaseSaveModel {

    /**
     * 
     * @param {GameModel} gameModel 
     * @param {Config} config 
     */
    constructor(gameModel, config) {
        super(config);
        this._gameModel = gameModel;
    }

    _createMinigameSaveGame() {
        return {
            elapsed: Math.round(this._gameModel.elapsedTime),
            index: this._gameModel.puzzleIndex,
            score: this._gameModel.score,
            mistakeCount: this._gameModel.mistakeCount,
            puzzle: this._gameModel.puzzle.toObject()
        };
    }
};
